import { ButtonV2 } from '@synoptic/ui-kit/button-v2/button-v2.js';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { CircleSparkIcon } from '@synoptic/ui-kit/icons/react/circle-spark.js';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.js';
import { clsx } from 'clsx';
import { useAuthGuard } from '@/components/auth-guard/auth-guard-provider.tsx';
import {
  summarizePostButton,
  summarizePostButtonCompact,
  summarizePostButtonIcon,
} from './summarize.css.ts';

export const SummarizePostButton = ({
  isSummaryVisible,
  onClick,
  compact,
  icon,
}: {
  isSummaryVisible: boolean;
  onClick: () => void;
  compact?: boolean;
  icon?: boolean;
}) => {
  const authGuard = useAuthGuard();
  const label = isSummaryVisible ? 'Hide summary' : 'Summarize post';
  const tooltip = isSummaryVisible ? 'Hide AI summary' : 'Summarize with AI';
  const handleClick = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
    if (authGuard()) return;
    onClick();
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {icon ? (
          <ButtonV2
            type="button"
            variant="secondary"
            size="icon"
            aria-label={label}
            aria-pressed={isSummaryVisible}
            className={clsx(summarizePostButton, summarizePostButtonIcon)}
            onClick={handleClick}
          >
            <CircleSparkIcon />
          </ButtonV2>
        ) : (
          <IconButton
            size="xSmall"
            variant="ghost"
            pressed={isSummaryVisible}
            aria-label={label}
            className={clsx(
              summarizePostButton,
              compact && summarizePostButtonCompact,
            )}
            onClick={handleClick}
          >
            <CircleSparkIcon />
          </IconButton>
        )}
      </TooltipTrigger>
      <TooltipContent side="bottom" description={tooltip} />
    </Tooltip>
  );
};
